import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import MyButton from '../../../shared-components/button/Button';
import CustomInput from '../../../shared-components/custom-input/CustomInput';
import CustomRadioButton from '../../../shared-components/custom-radio-button/CustomRadioButton';

interface BookMarkOptionInterface {
  addBookmark: (value: string | number) => void;
  close: () => void;
}

/**
 * Bookmark Option
 */
function BookmarkOption({ addBookmark, close }: BookMarkOptionInterface) {
  const { t } = useTranslation('reports');
  const [selectedOption, setSelectedOption] = useState('newBookmark');
  const [bookmarkName, setBookmarkName] = useState<string | number>('');

  /**
   * handleSubmit
   */
  const handleSubmit = (): void => {
    if (bookmarkName !== '') {
      addBookmark(bookmarkName);
    } 
  };

  return (
    <div className="bookmark-container">
      <div className="bookmark-options">
        <CustomRadioButton
          label={t('saveAsBookmark')}
          value="newBookmark"
          name="bookmark"
          selected={selectedOption === 'newBookmark'} // ✅ added
          onChangeFunc={() => setSelectedOption('newBookmark')}
        />
        <CustomRadioButton
          label={t('saveWithExistingBookmark')}
          value="saveBookmark"
          name="bookmark"
          selected={selectedOption === 'saveBookmark'} // ✅ added
          onChangeFunc={() => setSelectedOption('saveBookmark')}
        />
      </div>

      <div className="input-field">
        <CustomInput
          inputLabel={t('bookmarkName')}
          type="text"
          placeholder={t('enterName')}
          name="bookmarkName"
          value={bookmarkName}
          onChangeValue={(name: string, value: string | number) => setBookmarkName(value)}
          //   error={bookmarkName.trim() === ''}
          errorMessage={t('bookmarkNameIsRequired')}
        />
      </div>

      <div className="note-section">
        <p className="note-section-heading">{t('note')}</p>
        <p>
          <span className="note-section-sub-heading">{t('saveAsNew')}</span>{' '}
          {t('saveAsNewDescription')}
        </p>
        <p>
          <span className="note-section-sub-heading">{t('saveWithExisting')}</span>{' '}
          {t('saveWithExistingDescription')}
        </p>
        <p>
          <span className="note-section-sub-heading">{t('savedBookmarks')}</span>
        </p>
        {t('savedBookmarksDescription')}
      </div>

      <div className="form-buttons-wrap">
        <MyButton label={t('cancel')} buttonType="back" onClickFunc={close} />
        <MyButton label={t('save')} buttonType="submit" onClickFunc={handleSubmit} />
      </div>
    </div>
  );
}

export default BookmarkOption;
